import { Card, CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
// import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
// import { Image } from "react-bootstrap";
import DiagramMhsAktif from "../../component/Mahasiswa/Widget/DiagramMhsAktif";
// import DiagramIPK from "../../component/Mahasiswa/Widget/DiagramIPK";
// import DiagramMasaStudi from "../../component/Mahasiswa/Widget/DiagramMasaStudi";
import DiagramMhsAsing from "../../component/Mahasiswa/Widget/DiagramMhsAsing";
import axios from "axios";
import AppConfig from "../../../../config/AppConfig";


class MahasiswaPT extends Component {
    state = {
        loading: false,
        DiagramMhsAktif: [],
        DiagramMhsAsingPindahan:[],
        DiagramIkatan: [],
    }
    componentDidMount(){
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if(userdata){
            let id_sms = "";
            if(sessiondata.i_idsms !== undefined){
                id_sms = "&id_sms="+sessiondata.i_idsms
            }
            if(this.props.idSp !== undefined) {
                session = "?id_sp="+this.props.idSp+id_sms
            }else{
                session = "?id_sp="+sessiondata.i_idunit+id_sms
            }
        }
        let data_mhs        = AppConfig.MhsTerdaftar+session;
        let rq_mhs          = axios.get(data_mhs);
        axios.all([
            rq_mhs,
          ])
        .then(axios.spread((...responses) => {
            let respon_mhs              = responses[0];
            let data_mhs = {
                data_mhs_baru : respon_mhs.data.result.data_mhs_baru,
                data_mhs_asing : respon_mhs.data.result.data_mhs_asing,
                display: true,
            }
            this.setState({
                DiagramMhsAktif : data_mhs,
                DiagramMhsAsingPindahan : data_mhs,
                loading: true,
            });
        }))
        .catch(errors => {
        console.log(errors);
        });
    }
    componentDidUpdate(){
        let id_sms = "";
        if(this.props.displayProdi === true){
            id_sms = "&id_sms="+this.props.idSms;

            let userdata = JSON.parse(localStorage.getItem("userdata"));
            let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
            let session = "";
            if(userdata){
                if(this.props.idSp !== undefined) {
                    session = "?id_sp="+this.props.idSp+id_sms
                }else{
                    session = "?id_sp="+sessiondata.i_idunit+id_sms
                }
            }
            let data_mhs        = AppConfig.MhsTerdaftar+session;
            let rq_mhs          = axios.get(data_mhs);
            axios.all([
                rq_mhs,
            ])
            .then(axios.spread((...responses) => {
                let respon_mhs              = responses[0];
                let data_mhs = {
                    data_mhs_baru : respon_mhs.data.result.data_mhs_baru,
                    data_mhs_asing : respon_mhs.data.result.data_mhs_asing,
                    display: true,
                }
                this.setState({
                    DiagramMhsAktif : data_mhs,
                    DiagramMhsAsingPindahan : data_mhs,
                    loading: true,
                });
                this.props.handleCallbackDisplayProdi(false);
                this.props.handleCallbackSearch(false);
            }))
            .catch(errors => {
            console.log(errors);
            });
        }
        if(this.props.resetProdi === true){
            this.componentDidMount();
            this.props.handleCallbackResetProdi(false);
        }
    }
    render() {
        let {loading} = this.state;
        let display_data = [];
        if(loading === true){
            display_data = 
            <div className="row row-paddingless">
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramMhsAktif dataMhs={this.state.DiagramMhsAktif}/>
                    </Card>
                </div>
                {/* <div className="col-md-12" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramIPK/>
                    </Card>
                </div>
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramMasaStudi/>
                    </Card>
                </div> */}
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramMhsAsing dataMhs={this.state.DiagramMhsAsingPindahan}/>
                    </Card>
                </div>
            </div>;
        }else{
            display_data =
            <div style={{width:'100%', marginTop:'10%', textAlign:'center', verticalAlign:'middle'}}>
                <CircularProgress color="secondary" />
            </div>
            ;
        }
        return (display_data)
    }
}
export default MahasiswaPT;